import endpoint from "../../../../config/endpoints";
import { apiPost } from "../../../../utils/api_service";
import { getPdfDateRange } from "../../../Common/ProductWiseSkuPdf/utils/productWiseSkuPdfUtils";

// Build POST body for billing load sheet SKU-wise API.
export const buildLoadSheetSkuWisePostBody = () => {
  const lang = localStorage.getItem("lang");
  const loadsheetId = localStorage.getItem("loadSheetID");
  const { fromDate, toDate } = getPdfDateRange();

  return {
    outletBillHeaderIds: loadsheetId.split(","),
    fromDate,
    toDate,
    languageId: lang,
  };
};

export const fetchLoadSheetSkuWise = async () => {
  const postBody = buildLoadSheetSkuWisePostBody();
  return apiPost({
    url: endpoint.outletBillHeader + "/get-load-sheet-sku-wise",
    postBody,
  });
};
